export function getTwitterOAuthUrl() {
  const redirectUri = encodeURIComponent(getRedirectUri());
  return `https://x.com/i/oauth2/authorize?response_type=code&client_id=${import.meta.env.VITE_TWITTER_CLIENT_ID}&redirect_uri=${redirectUri}&scope=tweet.read%20users.read&state=state&code_challenge=challenge&code_challenge_method=plain`;
}

export function getRedirectUri() {
  return `${window.location.origin}/profile`;
}
